export default {
  //API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://intense-river-75386.herokuapp.com/api',
  TOKEN_KEY: 'velonotes-client-auth-token',
}